import React, { useEffect, useState } from 'react'
import useStateStore from '../../../store/stateStore';
import useAuthStore from '../../../store/authStore';
import { Button, message, Modal, Spin } from 'antd';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { format } from 'timeago.js'

const { confirm } = Modal;

function ViewAllNotifcations() {

    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);


    const { fetchNotifications,
        notificationDetails,
        notificationCount,
        markAsReadNotifications,
        markAllAsReadNotifications,
        deleteNotification,
        fetchLoading,
        markAsReadLoading,
        markAllAsReadLoading,
        deleteLoading
    } = useStateStore();

    const { user } = useAuthStore();
    const userId = user._id

    // console.log(notificationDetails, 'notificationDetails in page');
    // console.log(notificationCount, 'notificationCount in page');


    useEffect(() => {
        // console.log("usefffect called");
        const getNotifications = async () => {
            try {

                await fetchNotifications(1, 20, userId)
            } catch (error) {

            }
        }
        getNotifications()
    }, [])

    // useEffect(() => {
    //     console.log('i  useeffet');

    //     setNotifications(notificationDetails)
    //     setUnreadCount(notificationCount)
    // }, [notificationDetails, notificationCount])


    const markAsRead = async (notificationId) => {

        await markAsReadNotifications(notificationId, userId)
    };
    const markAllAsRead = async () => {


        await markAllAsReadNotifications(userId)
    };
    const handleDelete = async (notificationId) => {
        console.log("delete");

        // try {
        //     await deleteNotification(notificationId); // Call the API to delete
        //     setNotifications((prevNotifications) =>
        //         prevNotifications.filter((notification) => notification._id !== notificationId)
        //     );
        //     setUnreadCount((count) => Math.max(count - 1, 0));
        // } catch (error) {
        //     console.error("Failed to delete notification:", error);
        // }

        confirm({
            title: "Are you sure to delete?",
            icon: <AiOutlineExclamationCircle size={28} className='mx-2 text-orange-500' />,
            content: `If you delete, the notification will deleted`,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk() {
                deleteNotification(notificationId, userId)
            },
            onCancel() {
                console.log("Cancel");
            },
        });
        // await deleteNotification(notificationId)
    };

    if (fetchLoading) {
        return <p className='mt-5'>loading...</p>
    }
   

    return (
        <div>
            <Spin spinning={markAsReadLoading || deleteLoading}>
                <div className="p-3 py-4 border-b flex justify-end items-center">
                    {/* <span className="font-semibold text-sm ">Notifications</span> */}
                    {notificationCount > 0 && (
                        <Button loading={markAllAsReadLoading} className="mark-all-read border-none shadow-none p-0 h-5   text-xs text-blue-500" onClick={markAllAsRead}>Mark All as Read</Button>
                    )}
                </div>
                <div
                // className="max-h-60 overflow-y-auto"
                >
                    {notificationDetails?.length === 0 ? (
                        <div className="p-3 text-gray-500 text-sm">No notifications</div>
                    ) : (
                        notificationDetails?.map((notification) => {
                            const isUnread = notification?.reciversId?.some(
                                (receiver) => receiver.reciverId === userId && !receiver.isRead
                            );

                            return (
                                <div
                                    key={notification._id}
                                    className={`p-3 cursor-pointer flex justify-between items-center ${isUnread ? 'bg-white' : 'bg-gray-100'}`}
                                // onClick={() => markAsRead(notification._id)}

                                >
                                    <div className='flex  items-center w-4/5'
                                        onClick={() => !notification.reciversId.find(r => r.reciverId === userId).isRead && markAsRead(notification._id)}

                                    >
                                        {/* Dot for unread notifications */}
                                        {isUnread && (
                                            <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                                        )}
                                        <div className={`text-start ${isUnread ? '' : 'ml-4'}`}>

                                            <p className="text-sm">{notification.title}</p>
                                            <p className="text-[10px]">{notification.body}  {notification?.senderId?.name}. Check it out now!</p>
                                            <p className="text-[10px]">{format(notification.createdAt)}</p>
                                        </div>
                                    </div>
                                    <div className='mr-4'>
                                        <MdOutlineDeleteOutline onClick={() => handleDelete(notification._id)} />
                                    </div>

                                </div>
                            );
                        })

                    )}
                </div>
            </Spin>
        </div>
    )
}

export default ViewAllNotifcations